import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import InfoMessage from 'PointOfSale/modules/common/component/InfoMessage';
import ScrollContainer from 'PointOfSale/modules/common/container/ScrollContainer';
import GroupTeacherProfile from 'PointOfSale/modules/groupTeacher/component/GroupTeacherProfile';

const GroupTeacherServing = ({
  teacher,
  students,
  onProfileSelect,
  onSelectClick,
  showServingStatus,
}) => {
  if (_.isEmpty(teacher)) {
    return (
      <InfoMessage
        containerClass="group-teacher-empty-msg"
        message="Please use the Look Up to search."
      />
    );
  }
  return (
    <div className="flex-1 flex flex-col flex-no-wrap">
      <ScrollContainer enableScrollButtons className="flex-1">
        <Grid stretched className="teacher-profiles-grid">
          {_.map(students, (student, index) => (
            <Grid.Column
              key={index}
              mobile="4"
              tablet="3"
              computer="3"
              largeScreen="2"
            >
              <GroupTeacherProfile
                key={`${student.Id}${index}`}
                profile={student}
                onProfileSelect={onProfileSelect}
                onSelectClick={onSelectClick}
                showServingStatus={showServingStatus}
              />
            </Grid.Column>
          ))}
        </Grid>
      </ScrollContainer>
    </div>
  );
};
GroupTeacherServing.propTypes = {
  loading: PropTypes.bool,
  students: PropTypes.arrayOf(PropTypes.object),
  teacher: PropTypes.string,
  onProfileSelect: PropTypes.func,
  onSelectClick: PropTypes.func,
};

export default GroupTeacherServing;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/groupTeacher/component/GroupTeacherServing.js